import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Switch, Typography, Tooltip } from 'shared/ui'
import { type ContactOptIn } from 'entities/Contacts/model/ContactOptIn'
import { type ContactsOptInModalLocalStore } from 'widgets/ContactsOptInModal/store/contactsOptInModalLocalStore'
import styles from './styles.module.scss'

type IContactsOptInModalContentProps = {
  store: ContactsOptInModalLocalStore
}

export const ContactsOptInModalContent: FC<IContactsOptInModalContentProps> = observer(
  ({ store }) => {
    const { items } = store

    const getLabel = (isDisabled: boolean, isActive: boolean) => {
      if (isDisabled) return ''

      return isActive ? 'Active' : 'Contact manually opted out. You can turn this back on anytime.'
    }

    const renderItem = (item: ContactOptIn) => {
      const shortCodeText = item.formatted_number
        ? `${item.formatted_number}: ${item.name}`
        : item.name

      return (
        <div
          key={item.id}
          className={styles.section}
          onClick={() => {
            if (item.disabled) return
            item.handleChangeValue()
          }}
        >
          <Typography
            variant={'text-input-field'}
            className={styles.section__label}
            color={'var(--content-primary-tertiary)'}
            ariaLabel={'name'}
            ellipsis
            tooltipProps={{
              label: shortCodeText,
              placement: 'top',
              marginLeft: 30,
            }}
          >
            {shortCodeText}
          </Typography>

          <Tooltip label={getLabel(item.disabled, item.value)} placement='right' breakWord>
            <Switch
              value={item.value}
              disabled={item.disabled}
              ariaLabel={item.value ? 'enabled' : 'disabled'}
            />
          </Tooltip>
        </div>
      )
    }

    return (
      <div className={styles.wrap}>
        {items.map((item) => {
          if (item.disabled) {
            return (
              <Tooltip
                fullWidth
                key={item.id}
                label={item.disableLabel}
                placement={'right'}
                width={248}
                margin={6}
                breakWord
              >
                {renderItem(item)}
              </Tooltip>
            )
          }

          return renderItem(item)
        })}
      </div>
    )
  }
)
